import React, {useState, useEffect} from 'react'
import '../styles/layout.scss'

function AuthFloatingButton({scrollToDiv}:any) {
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const [lastScrollTop, setLastScrollTop] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (scrollTop < lastScrollTop) {
        // User is scrolling up
        setIsButtonVisible(true)
      } else {
        // User is scrolling down
        setIsButtonVisible(false)
      }
      setLastScrollTop(scrollTop)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollTop])

  return (
    <div className='App'>
      <div
        className={`floating-button text-center w-100 px-8 py-4 ${isButtonVisible ? 'show' : ''}`}
      >
        <button className='btn btn-primary w-100 custom-button-property' onClick={scrollToDiv}>Start Now</button>
        <p className='text-light mt-4 mb-0 fs-7 fw-normal'>No Credit Card Required.</p>
      </div>
    </div>
  )
}

export default AuthFloatingButton
